// The four double-book warning variants (Asana UNB double-book ticket), as one
// pure function so the copy can't drift across the two surfaces that show it:
// the DoubleBookModal (adding a catalog session) and the My Event modal's conflict
// view (adding/editing a custom event).
//
// Two facts pick the variant: whether the thing being ADDED is a session or a
// custom event, and whether the EXISTING conflicting item is a session or event.
// Only a custom event can be rescheduled — a catalog session's time is fixed — so
// the "or change the date/time" clause is offered only when a custom event is
// involved, and it points at whichever side is the event.
//
// The conflict title appears twice: once plainly ("you already have X"), once as
// the actionable mention ("please remove X"). Only the second is a link, so the
// copy is returned split around it — `before` + the (optionally linked) name +
// `after` — rather than as one string.

// Custom-event ids are prefixed `event:` (normalize-event.js); everything else is
// a catalog session unique_id.
export function conflictKindFromId(uniqueId) {
    return typeof uniqueId === 'string' && uniqueId.startsWith('event:') ? 'event' : 'session';
}

export function doubleBookCopy({ newTitle, newKind = 'session', conflictTitle, conflictKind = 'session' } = {}) {
    const newName = (newTitle && newTitle.trim()) || (newKind === 'event' ? 'this event' : 'this session');
    const conflictName = (conflictTitle && conflictTitle.trim()) || (conflictKind === 'event' ? 'another event' : 'another session');

    // "add the event “X”" for a custom event; just "add “X”" for a session.
    const opener = newKind === 'event' ? `the event “${newName}”` : `“${newName}”`;

    let suffix;
    if (newKind === 'event') {
        // Instances 3 & 4: the new custom event can always be moved.
        suffix = ` from My Schedule first or adjust the date/time of your “${newName}” event.`;
    } else if (conflictKind === 'event') {
        // Instance 2: the new session is fixed, but the existing custom event can move.
        suffix = ` from My Schedule or change the date/time of this event first.`;
    } else {
        // Instance 1: two fixed sessions — removing one is the only resolution.
        suffix = ` from My Schedule first.`;
    }

    return {
        before: `We can’t add ${opener} to My Schedule because you already have “${conflictName}” on My Schedule at the same time. Please remove “`,
        conflictName,
        after: `”${suffix}`,
    };
}
